import { makeStyles } from '@material-ui/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  info: {
    padding: '0.875rem 1rem',
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    lineHeight: '1.5rem',
    borderRadius: '1.25rem',
    backgroundColor: neutral['10'],
    border: `1px solid ${neutral['20']}`,
    '& > p[aria-label="info-name"]': {
      fontWeight: 500,
    },
    '& *': {
      fontFamily: 'PP Object Sans',
    },
  },
});
